import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicDailySessionDurationAggregate } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getDailyAggregatedSession = async ({
  from,
  to,
  organisationId,
}: {
  from: string;
  to: string;
  organisationId?: string;
}): Promise<PublicDailySessionDurationAggregate[]> => {
  const response = await axiosClient.get(
    `/analytics/average-session-duration`,
    {
      params: {
        from,
        to,
        organisationId,
      },
    },
  );
  return response.data;
};

export function getDailyAggregatedSessionQueryKey({
  from,
  to,
  organisationId,
}: {
  from: string;
  to: string;
  organisationId?: string;
}) {
  return ["daily-aggregated-session", from, to, organisationId];
}

export function useGetDailyAggregatedSession(
  {
    from,
    to,
    organisationId,
  }: {
    from: string;
    to: string;
    organisationId?: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<PublicDailySessionDurationAggregate[], HttpError>
  >,
) {
  return useQuery({
    queryKey: getDailyAggregatedSessionQueryKey({
      from,
      to,
    }),
    queryFn: () =>
      getDailyAggregatedSession({
        from,
        to,
        organisationId,
      }),
    ...queryOptions,
  });
}
